/*
  Loads featured images of combined listing child products for collection card swatches.
  Swatch spans carry data-product-url; each child product's featured image is fetched
  via the Section Rendering API (sections/swatch-image.liquid) and applied as the
  swatch background. Fetches are deduplicated per product URL and deferred until the
  card approaches the viewport. Any query string on the product URL (for example the
  tracking parameters Shopify adds to search result links) is stripped before the
  section ID is appended, so the Section Rendering API is always requested correctly.
*/
(function () {
  if (window.__aqSwatchImagesLoaded) return;
  window.__aqSwatchImagesLoaded = true;

  var cache = {};
  var lazy = 'IntersectionObserver' in window;
  var io = null;

  function apply(el, src) {
    if (src) el.style.backgroundImage = 'url("' + src + '")';
  }

  function load(el) {
    var url = el.dataset.productUrl;
    if (!url || el.dataset.swatchLoaded) return;
    el.dataset.swatchLoaded = 'true';
    var baseUrl = url.split('?')[0];
    if (cache[baseUrl] !== undefined) {
      apply(el, cache[baseUrl]);
      return;
    }
    fetch(baseUrl + '?section_id=swatch-image')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = (doc.body.textContent || '').trim();
        cache[baseUrl] = src;
        apply(el, src);
        if (!src) console.warn('Swatch image: no featured image for', baseUrl);
      })
      .catch(function (error) {
        console.warn('Swatch image: failed to load', baseUrl, error);
      });
  }

  function handle(el) {
    if (lazy) {
      io.observe(el);
    } else {
      load(el);
    }
  }

  function scan() {
    document
      .querySelectorAll('.product-card__swatch[data-product-url]')
      .forEach(handle);
  }

  if (lazy) {
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            load(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px' }
    );
  }

  scan();

  var scanTimer = null;
  new MutationObserver(function () {
    if (scanTimer) return;
    scanTimer = setTimeout(function () {
      scanTimer = null;
      scan();
    }, 200);
  }).observe(document.body, { childList: true, subtree: true });
})();
